// @ts-strict-ignore
import {Pipe, PipeTransform} from "@angular/core";
import {SimMarkersetService} from "@services";
import {from, Observable, of} from "rxjs";
import {Markerset} from "@models";

@Pipe({
	name: "getMarkerSetById",
	standalone: false,
})
export class GetMarkerSetByIdPipe implements PipeTransform {
	constructor(private _simMarkerSetService: SimMarkersetService) {}

	transform(markerSetId: string): Observable<Markerset> {
		if (!markerSetId) {
			return of(null);
		}
		return from(this._simMarkerSetService.getMarkersetById(markerSetId));
	}
}
